import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import { pinia } from "@/main";
import { useSystemStore } from "@/stores/system";
import { useAuthStore } from "@/stores/auth";
import { useHttpStore } from "@/stores/http";
// import VueGtag from "vue-gtag";

// VIEWS
import AboutRisePartner from "@/views/AboutRisePartner.vue";
import AboutRiseDistributor from "@/views/AboutRiseDistributor.vue";
import BonusDashboardPartner from "@/views/BonusDashboardPartner.vue";
import BonusDashboardDistributor from "@/views/BonusDashboardDistributor.vue";
import ContactUs from "@/views/ContactUs.vue";
import EligibleProducts from "@/views/EligibleProducts.vue";
import Login from "../views/LoginView.vue";
import HomeView from "@/views/HomeView.vue";
import HomePartner from "@/views/HomePartner.vue";
import HomeDistributor from "@/views/HomeDistributor.vue";

import RedirectAPJ from "@/components/RedirectAPJ.vue";
import MyPerformance from "@/views/MyPerformance.vue";

import RewardsCalculator from "@/views/RewardsCalculator.vue";
import Registration from "@/views/Registration.vue";
import UserProfile from "@/views/UserProfile.vue";
import Redemption from "@/views/Redemption.vue";
import RedemptionSummary from "@/views/RedemptionSummary.vue";
import DistributorEVoucherReport from "@/views/DistributorEVoucherReport.vue";
import PartnerEVoucherReport from "@/views/PartnerEVoucherReport.vue"
import ForgotPassword from "@/views/ForgotPassword.vue";
import Legals from "@/views/RiseLegals.vue";
import MarketingAssets from "@/views/MarketingAssets.vue";
import FAQView from "@/views/FAQView.vue";
import MessagesView from "@/views/MessagesView.vue";
import NewsView from "@/views/NewsView.vue";
import DistributorDashboard from "@/views/DistributorDashboard.vue";
import PartnerPerformance from "@/views/PartnerPerformance.vue";
import DistributorRedemptionReport from "@/views/DistributorRedemptionReport.vue";
import CreditNoteReport from "@/views/CreditNoteReport.vue";
import DnCP from '@/views/DnCP.vue';
import AdminView from "@/views/AdminView.vue";
import AdminImpersonateUser from "@/views/AdminImpersonateUser.vue";
import DellInternalReports from "@/views/DellInternalReports.vue";
import GoogleAnalytics from "@/views/GoogleAnalytics.vue";
import RewardsPaid from "@/views/RewardsPaid.vue"

//COMPONENTS
import PortalTermsAndConditions from "../components/PortalTermsAndConditions.vue";
import RISETermsAndConditions from "../components/RISETermsAndConditions.vue";
import PrivacyStatement from "../components/PrivacyStatement.vue";
import CookiesInformation from "@/components/CookiesInformation.vue";

import TestUpload from '@/components/FileUpload.vue'
// createWebHashHistory(),

const router = createRouter({
  history: createWebHashHistory(), // createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/apj",
      name: "apj",
      component: RedirectAPJ,
    },
    {
      path: "/",
      name: "login",
      component: Login,
      meta: {},
    },
    {
      path: "/home",
      name: "home",
      component: HomeView,
      beforeEnter: checkAuth,
      meta: {},
      children: [
        // {
        //   path: "/test",
        //   name: "test",
        //   component: TestUpload,
        // },
        {
          name: "home-partner",
          path: "partner",
          component: HomePartner,
          beforeEnter: checkAuth,
          meta: {
            authorisedRoles:['Partner', 'Dell', 'TIC_Admin']
          },
        },
        {
          name: "home-distributor",
          path: "distributor",
          component: HomeDistributor,
          beforeEnter: checkAuth,
          meta: {},
        },
        {
          name: "home-eligible-products",
          path: "eligible-products",
          component: EligibleProducts,
          beforeEnter: checkAuth,
          meta: {},
        },
        {
          name: "home-about-rise-partner",
          path: "about-rise-partner",
          component: AboutRisePartner,
          beforeEnter: checkAuth,
          meta: {},
        },
        {
          name: "home-about-rise-distributor",
          path: "about-rise-distributor",
          component: AboutRiseDistributor,
          beforeEnter: checkAuth,
          meta: {},
        },
        {
          name: "my-performance",
          path: "my-performance",
          component: MyPerformance,
          beforeEnter: checkAuth,
          meta: {},
        },
        {
          name: "bonus-dashboard-partner",
          path: "bonus-dashboard-partner",
          component: BonusDashboardPartner,
          beforeEnter: checkAuth,
          meta: {},
        },
        {
          name: "bonus-dashboard-distributor",
          path: "bonus-dashboard-distributor",
          component: BonusDashboardDistributor,
          beforeEnter: checkAuth,
        },
        {
          name: "rewards-calculator",
          path: "rewards-calculator",
          component: RewardsCalculator,
          beforeEnter: checkAuth,
        },
        {
          name: "user-profile",
          path: "user-profile",
          component: UserProfile,
          beforeEnter: checkAuth,
        },
        {
          name: "redemption",
          path: "redemption",
          component: Redemption,
          beforeEnter: checkAuth,
          meta: {},
        },
        {
          name: "redemption-summary",
          path: "redemption-summary",
          component: RedemptionSummary,
          beforeEnter: checkAuth,
          meta: {},
        },
        {
          name: "distributor-evoucher-report",
          path: "distributor-evoucher-report",
          component: DistributorEVoucherReport,
          beforeEnter: checkAuth,
          meta: {},
        },
        {
          path: "cookies-information",
          name: "cookies-information",
          component: CookiesInformation,
          beforeEnter: checkAuth,
        },
        {
          path: "privacy-statement",
          name: "privacy-statement",
          component: PrivacyStatement,
          beforeEnter: checkAuth,
        },
        {
          path: "terms-of-use",
          name: "terms-of-use",
          component: PortalTermsAndConditions,
          beforeEnter: checkAuth,
        },
        {
          path: "marketing-assets",
          name: "marketing-assets",
          component: MarketingAssets,
          beforeEnter: checkAuth,
        },
        {
          path: "contact-us",
          name: "contact-us",
          component: ContactUs,
          beforeEnter: checkAuth,
        },
        {
          path: "faq",
          name: "faq",
          component: FAQView,
          beforeEnter: checkAuth,
        },
        {
          path: "messages",
          name: "messages",
          component: MessagesView,
          beforeEnter: checkAuth,
        },
        {
          path: "news",
          name: "news",
          component: NewsView,
          beforeEnter: checkAuth,
        },
        {
          path: "distributor-dashboard",
          name: "distributor-dashboard",
          component: DistributorDashboard,
          beforeEnter: checkAuth,
        },
        {
          path: "partner-performance",
          name: "partner-performance",
          component: PartnerPerformance,
          beforeEnter: checkAuth,
        },
        {
          path: "distributor-redemption",
          name: "distributor-redemption",
          component: DistributorRedemptionReport,
          beforeEnter: checkAuth,
        },
        {
          path: "creditnote-report",
          name: "creditnote-report",
          component: CreditNoteReport,
          beforeEnter: checkAuth,
        },
        {
          path: "dell-internal-reports",
          name: "dell-internal-reports",
          component: DellInternalReports,
          beforeEnter: checkAuth,
        },
        {
          path: "dncp",
          name: "dncp",
          component: DnCP,
          beforeEnter: checkAuth,
        },
        {
          path: "partner-rewards-paid",
          name: "partner-rewards-paid",
          component: RewardsPaid,
          beforeEnter: checkAuth
        }
      ],
    },
    {
      name: "registration",
      path: "/registration",
      component: Registration,
    },
    {
      name: "forgot-password",
      path: "/forgot-password",
      component: ForgotPassword,
    },
    {
      path: "/info",
      name: "info",
      component: Legals,
      children: [
        {
          path: "cookies-information",
          name: "noauth-cookies-information",
          component: CookiesInformation,
        },
        {
          path: "privacy-statement",
          name: "noauth-privacy-statement",
          component: PrivacyStatement,
        },
        {
          path: "terms-of-use",
          name: "noauth-terms-of-use",
          component: PortalTermsAndConditions,
        },
        {
          path: "eligible-products",
          name: "noauth-eligible-products",
          component: EligibleProducts,
        },
        {
          path: "rewards-calculator",
          name: "noauth-rewards-calculator",
          component: RewardsCalculator,
        },
      ],
    },
    {
      path: "/admin",
      name: "admin",
      component: AdminView,
      beforeEnter: checkAuth,
    },    
    {
      path: "/google-analytics",
      name: "google-analytics",
      component: GoogleAnalytics,
      beforeEnter: checkAuth,
    },    
    {
      path: "/impersonateUser/:id",
      name: "impersonateUser",
      component: AdminImpersonateUser,
    },
  ],
});

function checkAuth(to, from, next) {
  const systemStore = useSystemStore(pinia);
  const authStore = useAuthStore(pinia);
  const httpStore = useHttpStore(pinia);

  

  systemStore.requestedRoute = to.name

  httpStore.token = sessionStorage.getItem("accessToken");
    
  if (httpStore.token != null && httpStore.token.trim().length > 0) {
    var ast = systemStore.getData("assets");

    systemStore
      .getUserDetails()
      .then((res) => {
        // the acess token is still valid
        if (res.success === true) {
          ast.tv = 1;
          systemStore.setData('assets', ast);

          // first check if otp was entered correctly
          if (ast.ua === 1 && ast.tv === 1 && ast.otp === 1) {
            systemStore.userDetail = res.userDetail;

            if (to.name === "admin") {
              if (systemStore.userDetail.userType.trim() === 'TIC_Admin' && systemStore.userDetail.affinityId === 987654321) {}
              else {
                return false;
              }
            }
                        
            if (systemStore.userDetail.userType.trim() === 'Distributor') {              
              if (to.name === "home-about-rise-partner") {
                next({ name: 'home-about-rise-distributor' })
              }
              else {
                next();
              }
            }
            else if (systemStore.userDetail.userType.trim() === 'Partner') {
              if (to.name === "home-about-rise-distributor") {
                next({ name: 'home-about-rise-partner' })
              }
              else {
                next();
              }
            }
            else {
              next();
            }
            
          } else {
            systemStore.showMessage('Unable to route to destination, please login.', {color:'error'})
            next("/");
          }
        } else {
          httpStore.token = "";
          next("/");
        }
      })
      .catch((error) => {
        httpStore.token = "";
        next("/");
      });
  } else {
    next("/");
  }
};


// afterEach
router.beforeEach((to, from, next) => {
  const toDepth = to.path.split("/").length;
  const fromDepth = from.path.split("/").length;
  to.meta.transition = toDepth < fromDepth ? "slide-right" : "slide-left";

  // next()

  // this is to add a manual delay between page transitions
  setTimeout(() => {
    next();
  }, 100);
});

// router.afterEach((to, from, next) => {
//   VueGtag('set', 'page', router.currentRoute.path);
//   VueGtag('send', 'pageview');

// router.afterEach(( to, from ) => {
//   VueGtag('set', 'page', to.path);
//   VueGtag('send', 'pageview');
// });

// });


export default router;
